import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITemplate } from "../templateModel";

export const getAllTemplates = createAsyncThunk(
  "WhatsappTemplate/FindAllWhatsappTemplate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsappTemplate/FindAllWhatsappTemplate`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Templates:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTemplate = createAsyncThunk(
  "WhatsappTemplate/InsertWhatsappTemplate",
  async (TemplateData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsappTemplate/InsertWhatsappTemplate`,
        TemplateData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating template:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTemplate = createAsyncThunk(
  "WhatsappTemplate/UpdateWhatsappTemplate",
  async (TemplateData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsappTemplate/UpdateWhatsappTemplate`,
        TemplateData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating template:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  "WhatsappTemplate/DeleteWhatsappTemplate",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsappTemplate/DeleteWhatsappTemplate`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting template:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTemplateByID = createAsyncThunk(
  "WhatsappTemplate/FindByIDWhatsappTemplate",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsappTemplate/FindByIDWhatsappTemplate`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        TemplateName: result.TemplateName,
        MetaApprovedTemplateName: result.MetaApprovedTemplateName,
        TemplateDescription: result.TemplateDescription,
        LanguageCode: result.LanguageCode,
        IsActive: result?.IsActive ? 1 : 2,
      } as ITemplate;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching template:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTemplates = createAsyncThunk(
  "WhatsappTemplate/FindAllActiveWhatsappTemplate",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WhatsappTemplate/FindAllActiveWhatsappTemplate`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Templates:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveTemplate = createAsyncThunk(
  "WhatsappTemplate/ActiveInActiveWhatsappTemplate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsappTemplate/ActiveInActiveWhatsappTemplate`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive template:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
